import React from 'react';
import { TitleContainer, StyledStarList } from './styles';
import { Typography } from '@material-ui/core';

const TitleWithStars = ({ title, stars }) => (
	<TitleContainer>
		<Typography variant="h2" color="textPrimary">
			{title}
		</Typography>
		<StyledStarList count={stars} />
	</TitleContainer>
);

export default TitleWithStars;
